import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import {isMobile} from 'react-device-detect';
import Config from '../../../Config';
import {connect} from 'react-redux';



const SplitBusinessEcommerceBannerMain = (props) => {
  
  
  const checkIfPrevPageIsCellcom=()=>{
    const prevPathname = sessionStorage.getItem('prevFullUrl');
    const regex = /https?:\/\/(www\.)?([a-zA-Z0-9.-]*)cellcom\.co\.il([a-zA-Z0-9@:%._\+~#?&//=]*)/;
    const isCellcomPage = regex.test(prevPathname);
    return isCellcomPage;
  }
  
  const handleClick = () => {
    const ecommerceOtpPageLink=props.contentData?.ecommerceOtpPageLink?.value;
    if (ecommerceOtpPageLink) {
      props.context.navigateTo(ecommerceOtpPageLink);
    }
  };
  const banner= isMobile
  ? props.contentData?.bannerImageMobile?.expandedValue?.url
  : props.contentData?.bannerImageDesktop?.expandedValue?.url;
  const isPrevPageValid=checkIfPrevPageIsCellcom();


  return( isPrevPageValid && props.isSplitCustomer?
      <div className='split-business-ecommerce-banner-style'>
        <Image className='page-pic' src={Config.epiBaseUrl + banner} onClick={()=>handleClick()} />
      </div>
  :null);
};

const mapStateToProps = (state) => {
  return {
    isSplitCustomer:state.welcomeBlock?.customerType?.isBusiness,
  };
};

const mapDispatchToProps = {
};
export default connect(mapStateToProps, mapDispatchToProps)(SplitBusinessEcommerceBannerMain);

